import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '韩漫', path: '/category/korean' },
      { label: '日漫', path: '/category/japanese' },
      { label: '国漫', path: '/category/chinese' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '常见问题', path: '/about' },
    ],
  },
  {
    title: '用户服务',
    links: [
      { label: '收藏夹', path: '/' },
      { label: '阅读记录', path: '/' },
      { label: '意见反馈', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="text-2xl font-heading text-background-50 hover:text-primary-400 transition-colors">
                丫丫漫画
              </Link>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                免费在线漫画阅读平台，韩漫、日漫、国漫热门分类，全集下拉式阅读，好看的漫画一网打尽。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-700/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 丫丫漫画 Yaya Comic. 本站所有漫画均来自网络，版权归原作者所有。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
                <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">服务条款</a>
                <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">版权声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}